import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerCard } from 'dm-src/models/customer-card';
import {
    BARCODE_FACTORY_SERVICE_IMPL,
    IBarcodeFactoryService,
} from 'dm-src/services/barcode-factory/ibarcode-factory.service';
import JsBarcode from 'jsbarcode';

@Component({
    selector: 'app-customer-card-container',
    templateUrl: './customer-card-container.component.html',
    styleUrls: ['./customer-card-container.component.scss'],
})
export class CustomerCardContainerComponent implements OnInit {
    public orderID: number;
    public customerCard: CustomerCard = new CustomerCard();
    public isInprogress: boolean;
    public hasCardToDisplay: boolean;
    @ViewChild('barcodeSvg') barcodeSvg!: ElementRef<SVGElement>;

    constructor(
        private _route: ActivatedRoute,
        @Inject(BARCODE_FACTORY_SERVICE_IMPL)
        private _barcodeFactoryService: IBarcodeFactoryService
    ) {}

    ngOnInit(): void {
        try {
            this.orderID = parseInt(this._route.snapshot.paramMap.get('{orderId}'));
        } finally {
            this.isInprogress = true;
            this._barcodeFactoryService.getBarcode(this.orderID).subscribe((response) => {
                if (response && response.barcode) {
                    console.log('Barcode response result:', response);

                    this.hasCardToDisplay = true;
                    this.isInprogress = false;

                    // A barcode generálása frontend oldalon pl. JsBarcode használatával
                    setTimeout(() => {
                        const format =
                            response.barcodeType === 'Interleaved2of5'
                                ? 'ITF'
                                : response.barcodeType === 'EAN13' &&
                                  !this.isEan13Compatible(response.barcode)
                                ? 'CODE128'
                                : 'EAN13';

                        try {
                            JsBarcode(this.barcodeSvg.nativeElement, response.barcode, {
                                format,
                                width: 2,
                                height: 60,
                                displayValue: true,
                            });
                        } catch {
                            JsBarcode(this.barcodeSvg.nativeElement, response.barcode, {
                                format: 'CODE128',
                                width: 2,
                                height: 60,
                                displayValue: true,
                            });
                        }

                        console.log('Barcode response result code:', response);
                        this.customerCard.barcodeData = response.barcode;
                        this.customerCard.providerName = response.providerName;
                    }, 100);
                } else {
                    this.hasCardToDisplay = false;
                }
                this.isInprogress = false;
                console.log('isinprogress:', this.isInprogress);
            });
        }
    }

    private isEan13Compatible(barcode: string): boolean {
        return /^\d{12,13}$/.test(barcode);
    }
}
